type StoreType = 'frames' | 'linkedAssets' | 'drafts' | string;

class LocalStorageManager<T extends { spaceId: string }> {
  private key: string;

  constructor(storeKey: StoreType) {
    this.key = `store_${storeKey}`;
  }

  getAll(): T[] {
    const data = localStorage.getItem(this.key);
    return data ? JSON.parse(data) : [];
  }

  getById(spaceId: string): T | undefined {
    const data = this.getAll();
    return data.find((item) => item.spaceId === spaceId);
  }

  add(item: T): void {
    const data = this.getAll();
    if (!data.some((existing) => existing.spaceId === item.spaceId)) {
      data.push(item);
      this.save(data);
    }
  }

  update(spaceId: string, updates: Partial<T>): boolean {
    const data = this.getAll();
    const index = data.findIndex((item) => item.spaceId === spaceId);

    if (index !== -1) {
      data[index] = { ...data[index], ...updates };
      this.save(data);
      return true;
    }
    return false;
  }

  remove(spaceId: string): boolean {
    const data = this.getAll();
    const filteredData = data.filter((item) => item.spaceId !== spaceId);

    if (filteredData.length !== data.length) {
      this.save(filteredData);
      return true;
    }
    return false;
  }

  clear(): void {
    localStorage.removeItem(this.key);
  }

  private save(data: T[]): void {
    localStorage.setItem(this.key, JSON.stringify(data));
  }
}

export default LocalStorageManager;
